import { useAuth } from '@frontegg/react';
import { useQuery } from '@tanstack/react-query';
import { AI_BYOK_SETTINGS } from '../constants/queryKeys';
import { ByokSettings, fetchByokSettings } from '../services/api';
import { isInSaaSMode } from '../utils/common';

const useByokSettings = (enabled: boolean = true) => {
  const authHook = isInSaaSMode() ? useAuth : null;
  const { isAuthenticated = true } = authHook?.() || {};
  const { data, isLoading, isFetched } = useQuery<ByokSettings>(
    [AI_BYOK_SETTINGS],
    fetchByokSettings,
    {
      enabled: enabled && isAuthenticated,
    },
  );

  const models = data?.allowedModels ?? [];

  return { data, models, isLoading, isFetched };
};

export default useByokSettings;
